module.exports = __webpack_public_path__ + "d49d1296291b969b11135830d94c84cd.svg";